export interface ClaimFormValues {
  companyId: string
  title: string
  category: string
  amount: string
  date: string
  description: string
  receiptIds: string[]
}

export type ClaimFormErrors = Partial<Record<keyof ClaimFormValues, string>>

export const MAX_CLAIM_RECEIPTS = 5

/** Same rules the API enforces, so most mistakes are caught before submit. */
export function validateClaimForm(values: ClaimFormValues, today: string): ClaimFormErrors {
  const errors: ClaimFormErrors = {}
  if (!values.companyId) errors.companyId = 'Choose the company this expense was for'
  const title = values.title.trim()
  if (!title) errors.title = 'Title is required'
  else if (title.length > 120) errors.title = 'Title must be 120 characters or fewer'
  if (!values.category) errors.category = 'Choose a category'
  const amount = Number(values.amount)
  if (!values.amount || !Number.isFinite(amount) || amount < 0.01) {
    errors.amount = 'Enter an amount of at least 0.01'
  }
  if (!values.date) errors.date = 'Date is required'
  else if (values.date > today) errors.date = 'The expense date cannot be in the future'
  if (values.description.length > 1000) {
    errors.description = 'Notes must be 1000 characters or fewer'
  }
  if (values.receiptIds.length === 0) errors.receiptIds = 'Attach at least one receipt'
  else if (values.receiptIds.length > MAX_CLAIM_RECEIPTS) {
    errors.receiptIds = `Attach at most ${MAX_CLAIM_RECEIPTS} receipts`
  }
  return errors
}
